import NProgress from 'nprogress'
import { useEffect } from 'react'
import { NProgressInit } from '~/common/nextJsUtils'

/**
 * A hook that renders a progress bar along the top of the webpage while
 * your useQuery is fetching (e.g. isFetching === true).
 *
 * This is great to indicate to users after a filter, search, or ordering
 * value has changed, they can understand that new data is being loaded,
 * because the progress bar is working. Then the data changes.
 *
 * @param isFetching
 */
export function useQueryProgressIndicator(
  isFetching: boolean,
  opts: { parentSelector?: string; color?: string; height?: number } = {}
) {
  useEffect(() => {
    let parent: string | undefined
    if (opts.parentSelector && document.querySelector(opts.parentSelector)) {
      parent = opts.parentSelector
    }
    NProgressInit({ parent, color: opts.color, height: opts.height })
    if (isFetching) {
      NProgress.start()
    } else {
      NProgress.done()
    }
    return () => {
      // useEffect cleanup runs after the custom parent node is gone. nprogress still
      // holds that selector and throws on trickle/done/remove (`className` of null).
      NProgressInit()
      NProgress.done()
    }
  }, [isFetching])
}
